import React from 'react'
import { Route } from 'react-router-dom'

import SearchResultsView from 'components/SearchResultsView'

const SearchResultsRoutes = ({ match }) => (
  <>
    <Route exact path={`${match.path}/`} component={SearchResultsView} />
  </>
)

export default SearchResultsRoutes
